import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../foundations/icons/Icon.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { s as styles } from "../../../chunks/Badge.module-BQ48tBve.js";
import { $ as $701a24aa0da5b062$export$ea18c227d4417cc3 } from "../../../chunks/useButton-BIR5vkbu.js";
const BadgeButton = forwardRef(
  ({ children, onPress, isDismissable, isSelected, ...props }, ref) => {
    const buttonRef = useRef(null);
    const { buttonProps, isPressed } = $701a24aa0da5b062$export$ea18c227d4417cc3({ onPress, preventFocusOnPress: true }, buttonRef);
    return /* @__PURE__ */ jsx(
      "button",
      {
        ref,
        className: clsx(styles.badge, {
          [styles.badgeIsPressed]: isPressed,
          [styles.badgeIsDismissible]: isDismissable,
          [styles.badgeIsSelected]: isSelected
        }),
        ...buttonProps,
        ...props,
        children: /* @__PURE__ */ jsxs(Text, { component: "span", variant: "text-body-head", className: styles.badgeText, children: [
          children,
          isDismissable ? /* @__PURE__ */ jsx(Icon, { variant: "XSmall", "aria-hidden": true }) : null
        ] })
      }
    );
  }
);
export {
  BadgeButton
};
